export interface DateTrackingSettings {
  tracksExpiry?: boolean;
  tracksReview?: boolean;
}
export interface TrackingCategory extends DateTrackingSettings {
  id: string;
  parentId?: string | null;
}

/** Enabled ancestor settings cannot be disabled by descendants. Cycles terminate safely. */
export function categoryTracking(
  categoryId: string | null | undefined,
  categories: ReadonlyMap<string, TrackingCategory>,
): Required<DateTrackingSettings> {
  const result = { tracksExpiry: false, tracksReview: false };
  const seen = new Set<string>();
  let current = categoryId;
  while (current && !seen.has(current)) {
    seen.add(current);
    const category = categories.get(current);
    if (!category) break;
    result.tracksExpiry ||= category.tracksExpiry === true;
    result.tracksReview ||= category.tracksReview === true;
    current = category.parentId;
  }
  return result;
}

export function equipmentTracking(
  equipment: DateTrackingSettings & { categoryId?: string },
  categories: ReadonlyMap<string, TrackingCategory>,
): Required<DateTrackingSettings> {
  const inherited = categoryTracking(equipment.categoryId, categories);
  return {
    tracksExpiry: equipment.tracksExpiry === true || inherited.tracksExpiry,
    tracksReview: equipment.tracksReview === true || inherited.tracksReview,
  };
}
